import React from 'react';

import { Button } from '@swyftx/aviary/atoms/Button';

import PrivateRoute from '@routes/PrivateRoute';

import { Save, Trash } from 'lucide-react';
import { SwyftxAppShellCustomHeader } from 'src/lib/layout/SwyftxAppShellCustomHeader';
import { useNavigateRoute } from 'src/lib/navigation/hooks';
import { NavigationURLs } from 'src/lib/navigation/types/navigationURL.types';

import LoanApplication from './LoanApplication';
import { LoanApplicationProvider } from '../../../features/loans/xstate/LoanApplication.context';

export const LoanApplicationRoute: React.FC = () => {
  const { navigate } = useNavigateRoute();
  // TODO: check if NZ
  // TODO: check if entity

  // if (!isFeatureEnabled(AppFeature.LoanApplicationWizard) || isEntity()) {
  //   return <Navigate to={NavigationURLs.ProfileVerification} />;
  // }

  const handleExit = () => {
    // TODO: analytics, ensure data is saved
    navigate(NavigationURLs.Dashboard);
  };

  return (
    // TODO: convert AppShell to aviary (maybe...)
    <SwyftxAppShellCustomHeader
      headerItemOverride={
        <>
          <Button leadingIcon={<Trash />} variant='outlined'>
            Cancel application
          </Button>
          <Button leadingIcon={<Save />} onClick={handleExit}>
            Save & exit
          </Button>
        </>
      }
    >
      <PrivateRoute
        element={
          <LoanApplicationProvider>
            <LoanApplication handleExit={handleExit} />
          </LoanApplicationProvider>
        }
      />
    </SwyftxAppShellCustomHeader>
  );
};
